import environment from "./environment";

const stageValues = {
  accessToken: "accesToken_stage",
  loginTime: "loginTime_stage",
  clearTime: "clearTime_stage",
  adminName: "adminName_stage",
  refreshToken: "refreshToken_stage",
  fcmToken: "fcmToken_stage_cmd",
  deviceId: "deviceId_stage_cmd",
  activeList: "active_list_stage_cmd",
  auth: "auth_token_stage_cmd",
  privilege: "admin_privilege_stage_cmd",
};

const prodValues = {
  accessToken: "accesToken_FV_CMD",
  loginTime: "loginTime_FV_CMD",
  clearTime: "clearTime_FV_CMD",
  adminName: "adminName_FV_CMD",
  refreshToken: "refreshToken_FV_CMD",
  fcmToken: "fcmToken_FV_CMD",
  deviceId: "deviceId_FV_CMD",
  activeList: "active_list_FV_CMD",
  auth: "auth_token_FV_CMD",
  privilege: "admin_privilege_FV_CMD",
};

const dynamicStrings = environment.envType === "PRODUCTION" ? prodValues : stageValues;

export default dynamicStrings;
